import React from 'react';
import type ProjectsConnectType from '@atlassian/jira-spa-apps-connect-projects/src/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/** @deprecated delete file on FG clean up 'sv-122-migrate-archived-issues-to-entrypoint' */
export const LazyProjectsConnect = lazyForPaint<typeof ProjectsConnectType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-connect-projects", jiraSpaEntry: "async-connect-projects" */ '@atlassian/jira-spa-apps-connect-projects/src/index-old.tsx'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyProjectsConnect} pageId="connect-projects" shouldShowSpinner />
);
